



import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

function SendFormPage() {
  const [agents, setAgents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();
  const [showPendingOnly, setShowPendingOnly] = useState(false);





// const [progress, setProgress] = useState(null); // add this state near your other useState calls





  // 🖱️ Mouse Tracking for Spotlight Effect
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    try {
      const res = await API.get("/agents/all");
      setAgents(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredAgents = agents
    .filter((a) => {
      const matchSearch =
        a.mail_id?.toLowerCase().includes(search.toLowerCase()) ||
        a.name_as_per_pan?.toLowerCase().includes(search.toLowerCase());

      const matchStatus = showPendingOnly ? a.status !== "sent" : true;

      return matchSearch && matchStatus;
    })

  const handleSelect = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((i) => i !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  const handleSelectAll = () => {
    if (selected.length === filteredAgents.length && filteredAgents.length > 0) {
      setSelected([]);
    } else {
      setSelected(filteredAgents.map((a) => a.id));
    }
  };




  const handleSend = async () => {
    if (selected.length === 0) {
      alert("Select at least one agent");
      return;
    }
    try {
      setLoading(true);
      await API.post("/form/send-bulk", { agent_ids: selected });
      alert("✅ Forms sent successfully");
      fetchAgents();
      setSelected([]);
    } catch (err) {
      alert("❌ Failed to send bulk forms");
    } finally {
      setLoading(false);
    }
  };







//   const handleSend = async () => {
//   if (selected.length === 0) {
//     alert("Select at least one agent");
//     return;
//   }

//   try {
//     setLoading(true);

//     // 1) Kick off the bulk send job (returns instantly now)
//     const { data } = await API.post("/form/send-bulk", { agent_ids: selected });
//     const jobId = data.job_id;

//     // 2) Poll for status until completed/error
//     const pollStatus = () =>
//       new Promise((resolve, reject) => {
//         const interval = setInterval(async () => {
//           try {
//             const { data: status } = await API.get(`/form/send-bulk/status/${jobId}`);

//             // optional: show live progress like "Sending 3 of 8..."
//             setProgress(status); // e.g. { status, success, failed, processed, total }

//             if (status.status === "completed") {
//               clearInterval(interval);
//               resolve(status);
//             } else if (status.status === "error") {
//               clearInterval(interval);
//               reject(new Error(status.error || "Bulk send failed"));
//             }
//           } catch (pollErr) {
//             clearInterval(interval);
//             reject(pollErr);
//           }
//         }, 2000); // poll every 2s
//       });

//     const finalStatus = await pollStatus();

//     alert(`✅ Forms sent: ${finalStatus.success} succeeded, ${finalStatus.failed} failed`);
//     fetchAgents();
//     setSelected([]);
//   } catch (err) {
//     alert("❌ Failed to send bulk forms");
//   } finally {
//     setLoading(false);
//     setProgress(null);
//   }
// };





  const handleSingleSend = async (id) => {
    try {
      await API.post(`/form/send/${id}`);
      fetchAgents();
    } catch (err) {
      console.error(err);
      alert("❌ Failed to send form");
    }
  };

  return (
    <div className="send-page-wrapper">
      <style>{`
        .send-page-wrapper {
          min-height: 100vh;
          background: #020617;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          padding: 60px 20px 120px 20px;
          position: relative;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(59, 130, 246, 0.08) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        .container {
          max-width: 1100px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        /* --- HEADER --- */
        .header { text-align: center; margin-bottom: 40px; }
        .header h1 {
          font-size: 36px; font-weight: 800; letter-spacing: -1.5px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
        }
        .header p { color: #64748b; margin-top: 5px; }

        /* --- SEARCH & ACTION BAR --- */
        .controls {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          background: rgba(255, 255, 255, 0.02);
          padding: 20px;
          border-radius: 24px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
        }

        .search-box input {
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          padding: 12px 20px;
          border-radius: 14px;
          color: white;
          width: 300px;
          outline: none;
          transition: 0.3s;
        }
        .search-box input:focus { border-color: #fbbf24; }

        .action-bar { display: flex; align-items: center; gap: 20px; }
        
        .bulk-send-btn {
          background: #fbbf24;
          color: #020617;
          border: none;
          padding: 12px 25px;
          border-radius: 12px;
          font-weight: 800;
          cursor: pointer;
          transition: 0.3s;
        }
        .bulk-send-btn:disabled { background: #1e293b; color: #475569; cursor: not-allowed; }
        .bulk-send-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 20px rgba(251, 191, 36, 0.2); }

        /* --- TABLE --- */
        .table-container {
          background: rgba(255, 255, 255, 0.02);
          border-radius: 28px;
          border: 1px solid rgba(255, 255, 255, 0.08);
          overflow: hidden;
          backdrop-filter: blur(20px);
        }

        table { width: 100%; border-collapse: collapse; text-align: left; }
        th { padding: 20px; background: rgba(255,255,255,0.03); color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 1px; }
        td { padding: 18px 20px; border-bottom: 1px solid rgba(255,255,255,0.03); font-size: 14px; }
        tr:hover td { background: rgba(255,255,255,0.01); }

        .status {
          padding: 4px 10px; border-radius: 8px; font-size: 11px; font-weight: 700; text-transform: uppercase;
        }
        .status.sent { background: rgba(34, 197, 94, 0.1); color: #22c55e; }
        .status.pending { background: rgba(251, 191, 36, 0.1); color: #fbbf24; }

        .row-btn {
          padding: 8px 16px; border-radius: 10px; border: 1px solid rgba(255,255,255,0.1);
          background: transparent; color: white; cursor: pointer; transition: 0.3s; font-size: 12px; font-weight: 600;
        }
        .row-btn.send:hover { background: #fbbf24; color: #020617; border-color: #fbbf24; }
        .row-btn.resend:hover { background: rgba(255,255,255,0.1); }

        /* 📍 BACK BUTTON */
        .back-btn-fixed {
          position: fixed; bottom: 30px; left: 30px;
          width:15rem;
          background: rgba(255, 255, 255, 0.05); backdrop-filter: blur(12px);
          border: 1px solid rgba(255, 255, 255, 0.1); color: #94a3b8;
          padding: 14px 24px; border-radius: 16px; cursor: pointer; font-weight: 700;
          z-index: 100; transition: 0.3s; display: flex; align-items: center; gap: 10px;
        }
        .back-btn-fixed:hover { background: rgba(255, 255, 255, 0.1); color: white; transform: translateX(6px); }

        input[type="checkbox"] {
          accent-color: #fbbf24;
          width: 18px; height: 18px;
          cursor: pointer;
        }
      `}</style>

      <div className="spotlight"></div>

      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> Back to Dashboard
      </button>

      <div className="container">
        <header className="header">
          <h1>📤 Send CA Forms</h1>
          <p>Bulk distribute commission agent agreements</p>
        </header>

        <div className="controls">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search by name or email..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="action-bar">
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                onChange={handleSelectAll}
                checked={selected.length === filteredAgents.length && filteredAgents.length > 0}
              />
              Select All
            </label>
            <span style={{ color: '#64748b', fontSize: '14px' }}>|</span>
            <span style={{ fontWeight: '700', fontSize: '14px', color: selected.length > 0 ? '#fbbf24' : 'inherit' }}>
              {selected.length} Selected
            </span>
            <button className="bulk-send-btn" onClick={handleSend} disabled={loading || selected.length === 0}>
              {loading ? "⌛ Processing..." : "🚀 Send Selected"}
            </button>


            <button
              onClick={() => setShowPendingOnly(!showPendingOnly)}
              style={{
                padding: "10px 16px",
                borderRadius: "10px",
                border: "1px solid rgba(255,255,255,0.1)",
                background: showPendingOnly ? "#fbbf24" : "transparent",
                color: showPendingOnly ? "#020617" : "white",
                cursor: "pointer",
                fontWeight: "600"
              }}
            >
              {showPendingOnly ? "📋 Show All" : "⏳ Pending Only"}
            </button>


          </div>
        </div>

        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th style={{ width: '50px' }}></th>
                <th>Agent Name</th>
                <th>Email Address</th>
                <th>Current Status</th>
                <th style={{ textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAgents.map((agent) => (
                <tr key={agent.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selected.includes(agent.id)}
                      onChange={() => handleSelect(agent.id)}
                    />
                  </td>
                  <td style={{ fontWeight: '600' }}>{agent.name_as_per_pan}</td>
                  <td style={{ color: '#94a3b8' }}>{agent.mail_id}</td>
                  <td>
                    <span className={`status ${agent.status || 'pending'}`}>
                      {agent.status || 'pending'}
                    </span>
                  </td>
                  <td style={{ textAlign: 'right' }}>
                    <button
                      className={`row-btn ${agent.status === "sent" ? "resend" : "send"}`}
                      onClick={() => handleSingleSend(agent.id)}
                    >
                      {agent.status === "sent" ? "🔄 Resend" : "📩 Send Form"}
                    </button>
                  </td>
                </tr>
              ))}
              {filteredAgents.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '50px', color: '#64748b' }}>
                    No agents found matching your search.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SendFormPage;